export enum DataBaseStatus {
  PREPARING = "preparing",
  PREPARED = "prepared",
  PREPARATION_FAILED = "preparation_failed",
  RESTORING = "restoring",
  RESTORED = "restored",
  RESTORE_FAILED = "restore_failed",
  DELETING ="deleting",
  DELETED = "deleted",
  DELETE_FAILED = "deletion_failed",
  PROMOTING = "promoting",
  PROMOTED = "promoted",
  PROMOTION_FAILED = "promotion_failed",
  DELETE_FAIL = "delete failed",
  FAILED = "failed",
  RESTORE_FAIL = "restore failed",
  SETTING_UP = "Setting Up",
  READY_TO_RESTORE = "Ready to Restore",
  SETTING_UP_FAILED = "Setting up Failed"
}

export const dataBaseStatus = Object.values(DataBaseStatus);
